import React from 'react'

import {
  AlignItems,
  BorderStyle,
  Box,
  Color,
  Display,
  DisplayPosition,
  FlexDirection,
  FontWeight,
  Icon,
  IconVariant,
  JustifyContent,
  Text,
  withCitrusTheme,
} from '@gousto-internal/citrus-react'

type CustomisationEducationProps = {
  onClose: () => void
}

const EducationArrow = withCitrusTheme(Box, (theme) => ({
  borderBottom: `10px solid ${theme.color(Color.ColdGrey_900)}`,
  borderLeft: '5px solid transparent',
  borderRight: '5px solid transparent',
  height: 0,
  position: DisplayPosition.Absolute,
  right: '45px',
  top: '-10px',
  width: 0,
  [`@media (min-width: ${theme.tokens.breakpoints[1]})`]: {
    right: '50px',
  },
}))

const EducationCloseButton = withCitrusTheme('button', () => ({
  appearance: 'none',
  alignItems: AlignItems.Center,
  backgroundColor: 'transparent',
  border: 0,
  color: 'inherit',
  cursor: 'pointer',
  display: Display.Flex,
  margin: 0,
  padding: 0,
  '&:focus-visible': {
    outline: '2px solid #615CFF',
    outlineOffset: '2px',
  },
}))

const preventPropagation = (event: React.SyntheticEvent) => event.stopPropagation()

export const CustomisationEducation = ({ onClose }: CustomisationEducationProps) => {
  const handleClose = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation()
    onClose()
  }

  return (
    <Box
      data-testid="recipe-tile-customisation-education"
      onClick={preventPropagation}
      onKeyDown={preventPropagation}
      width="100%"
    >
      <EducationArrow />
      <Box
        alignItems={AlignItems.FlexStart}
        bg={Color.ColdGrey_900}
        borderRadius={1.5}
        borderStyle={BorderStyle.Solid}
        color={Color.White}
        display={Display.Flex}
        flexDirection={FlexDirection.Column}
        paddingH={3}
        paddingV={3}
        width="100%"
      >
        <Box
          alignItems={AlignItems.Center}
          display={Display.Flex}
          justifyContent={JustifyContent.SpaceBetween}
          paddingBottom={2}
          width="100%"
        >
          <Text size={3} fontWeight={FontWeight.Bold}>
            Your recipe, your way
          </Text>
          <EducationCloseButton
            aria-label="Close customisation education"
            data-testid="recipe-tile-customisation-education-close"
            onClick={handleClose}
            type="button"
          >
            <Icon name="close" variant={IconVariant.Inherit}>
              Close tooltip
            </Icon>
          </EducationCloseButton>
        </Box>
        <Text color={Color.White} size={1}>
          We pick the option we think you&apos;ll love and you can customise as you choose.
        </Text>
      </Box>
    </Box>
  )
}
